import { render } from "./ribbons.vue?vue&type=template&id=c9e12b50"
import script from "./ribbons.vue?vue&type=script&lang=js"
export * from "./ribbons.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__